/*
 * FOR SALE — carrousel « Avis récents » (snippet fs-reviews-carousel, décision 014). Amélioration progressive : sans ce
 * script, la rangée défile déjà au doigt, à la molette et au clavier (zone focalisable, scroll-snap).
 *  - Boutons « Avis précédents » / « Avis suivants » affichés seulement si la rangée déborde ; ils avancent d'une largeur
 *    visible, au mouvement réduit près (prefers-reduced-motion : saut direct).
 *  - En bout de rangée, le bouton concerné porte aria-disabled (il garde le focus, au contraire de disabled).
 *  - Aucun défilement automatique.
 */
(function () {
  'use strict';
  const reduced = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  function setup(root) {
    const track = root.querySelector('[data-fs-rk-track]');
    const controls = root.querySelector('[data-fs-rk-controls]');
    const prev = root.querySelector('[data-fs-rk-prev]');
    const next = root.querySelector('[data-fs-rk-next]');
    if (!track || !controls || !prev || !next) return;

    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      controls.hidden = max <= 1;
      prev.setAttribute('aria-disabled', String(track.scrollLeft <= 1));
      next.setAttribute('aria-disabled', String(track.scrollLeft >= max - 1));
    };
    const step = (direction) => {
      const max = track.scrollWidth - track.clientWidth;
      const target = Math.max(0, Math.min(max, track.scrollLeft + direction * track.clientWidth * 0.9));
      track.scrollTo({ left: target, behavior: reduced() ? 'auto' : 'smooth' });
    };
    prev.addEventListener('click', () => { if (prev.getAttribute('aria-disabled') !== 'true') step(-1); });
    next.addEventListener('click', () => { if (next.getAttribute('aria-disabled') !== 'true') step(1); });
    let frame = 0;
    track.addEventListener('scroll', () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => { frame = 0; update(); });
    }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    else window.addEventListener('resize', update);
    update();
  }

  const start = () => document.querySelectorAll('[data-fs-rk]').forEach((root) => {
    try { setup(root); } catch (error) { /* rangée défilante sans boutons */ }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
